// Snapshot of SEO tags shipped in the prerendered HTML, captured before React mounts.
// Verification tags (google/bing/pinterest) are intentionally not selected so they are never removed.
const SEO_SELECTOR = [
  'title',
  'meta[name="title"]',
  'meta[name="description"]',
  'meta[name="robots"]',
  'meta[name="googlebot"]',
  'meta[property^="og:"]',
  'meta[name^="twitter:"]',
  'link[rel="canonical"]',
  'link[rel="alternate"][hreflang]',
  'script[type="application/ld+json"]',
].join(',');

const hasDom = typeof document !== 'undefined';
let prerenderedNodes = hasDom ? Array.from(document.head.querySelectorAll(SEO_SELECTOR)) : [];

export const LANDING_PATH = hasDom ? window.location.pathname : null;

export const hasPrerenderedHead = () => prerenderedNodes.length > 0;

export const releasePrerenderedHead = () => {
  prerenderedNodes.forEach((el) => el.remove());
  prerenderedNodes = [];
};
